import React from "react";

function ReferralHospitals() {
    const referralHospitals = [
        "Amara Hospital –  0877 6690000, 7993933777 (OP & IP Services)",
        "SVIMS Hospital - 0877 2287777 (OP & IP Services)",
        "Aster Narayanadri Hospital, Tirupati - 0877 223 3449 (OP & IP Services)",
        "Sankalpa Super Speciality Hospital, Tirupati - 0877-2227722 (OP & IP Services)",
        "Ankura Hospital for Women and Children,Tirupati - 9053 108 108 ( OP Services)",
        "Dr. Agarwal’s Health Care Ltd, Tirupati - 08048195010 (OP & IP Services)",
        "Meghana Multi speciality Dental Hospital, Tirupati - 078933 27036",
        "Firoz Dental Hospital - 097045 82322 Tirupati",
        "Haripriya Dental Hospital - 098494 99459",
        "Sri Maruthi Hospitals, Tirupati - 087905 29777",
        "Krishna Scan Centre (will give special discounts to our employees on institute doctor prescription) - 0877 222 2900",
    ];
    return (
        <div className="white-bg" style={{ padding: "20px" }}>
            <div>
                <h2>Referral Hospitals</h2>
                <ul>
                    {referralHospitals.map((item, index) => (
                        <li
                            key={index}
                            className="caboutus"
                            style={{ display: "flex", flexDirection: "row" }}
                        >
                            <i
                                className="icon fal fas fa-caret-right pl-5"
                                style={{
                                    display: "block",
                                    alignSelf: "flex-start",
                                    marginTop: "0.31lh",
                                }}
                            />
                            <p className="pl-10">{item}</p>
                        </li>
                    ))}
                </ul>
            </div>

            <br />

            <div>
                <h2>Labs</h2>
                <div
                    className="caboutus"
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    <i
                        className="icon fal fas fa-caret-right pl-5"
                        style={{
                            display: "block",
                            alignSelf: "flex-start",
                            marginTop: "0.31lh",
                        }}
                    />
                    <p className="pl-10">Vijaya Diagnostic Centre Limited</p>
                    </div>
                     <div
                    className="caboutus"
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    <i
                        className="icon fal fas fa-caret-right pl-5"
                        style={{
                            display: "block",
                            alignSelf: "flex-start",
                            marginTop: "0.31lh",
                        }}
                    />
                    <p className="pl-10">Apollo Diagnostics</p>
                </div>
            </div>

            <br />

            <div>
                <h3>MOU with Pharmacies</h3>
                <div
                    className="caboutus"
                    style={{ display: "flex", flexDirection: "row" }}
                >
                    <i
                        className="icon fal fas fa-caret-right pl-5"
                        style={{
                            display: "block",
                            alignSelf: "flex-start",
                            marginTop: "0.31lh",
                        }}
                    />
                    <p className="pl-10">
                        Srivari Medical Store, Near Leelamahal Circle, Tirupati.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default ReferralHospitals;
